import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

import type { FlagsStateContainer } from '@confluence/flags';

import { showInvitePromptFlag } from '../ui/InviteOnPublishFlags';

import {
	fireEligibilityChecked,
	fireExperimentError,
	fireFeatureExposed,
	getExperimentAnalytics,
} from './analytics';
import { resolveInviteOnPublish } from './resolve-invite-on-publish';
import { isFeatureVisited, isUserOptedOut } from './feature-visited';
import { isExperimentEnabled } from './feature-flag';

export interface InviteOnPublishInput {
	cloudId: string;
	userId: string | null;
	createAnalyticsEvent: CreateUIAnalyticsEvent;
	flags?: FlagsStateContainer;
}

export const triggerInviteOnPublishExperiment = async ({
	cloudId,
	userId,
	flags,
	createAnalyticsEvent,
}: InviteOnPublishInput) => {
	const analytics = getExperimentAnalytics(createAnalyticsEvent);

	try {
		if (!userId || isFeatureVisited()) {
			return;
		}

		const response = await resolveInviteOnPublish({ userId, cloudId });
		if (response.ineligibilityReason !== null) {
			fireEligibilityChecked(analytics, response.ineligibilityReason);
		} else if (response.collaborators !== null) {
			fireEligibilityChecked(analytics, 'ELIGIBLE');
			fireFeatureExposed(analytics);
			if (!isExperimentEnabled() || isUserOptedOut()) return;
			const continueUrl = `${window.location.origin}/wiki`;
			const invitees = response.collaborators.map(({ id, name, avatar }) => ({ id, name, avatar }));
			showInvitePromptFlag(invitees, continueUrl, cloudId, createAnalyticsEvent, flags);
		}
	} catch (error: any) {
		fireExperimentError(analytics, error);
	}
};
